module.exports = __webpack_public_path__ + "img/4-3.c5456c57.png";